<template>
  <div>
    <li :class="isshow ? 'dropdown notification-list show':'dropdown notification-list'">
      <a class="nav-link dropdown-toggle arrow-none" @click="toggleNotifications()">
        <i class="icon-bell"></i>
        <span class="noti-icon-badge" v-if="isShowOrderBadge"></span>
      </a>
      <div
        :class="isshow ? 'dropdown-menu dropdown-menu-right dropdown-menu-animated dropdown-lg show' :'dropdown-menu dropdown-menu-right dropdown-menu-animated dropdown-lg'"
        id="mydropdown"
        class="notification-dropdown"
        x-placement="bottom-end"
      >
        <!-- item-->
        <div class="dropdown-item noti-title">
          <h5 class="m-0">Notification</h5>
        </div>

        <div class="notification-scroll-container">
          <div class="simplebar-wrapper">
            <div class="simplebar-content" v-if="notifications.length > 0">
              <!-- item-->
              <a class="dropdown-item notify-item" v-for="item in notifications" :key="item.id">
                <div class="notify-icon bg-primary">
                  <i class="mdi mdi-comment-account-outline"></i>
                </div>
                <p class="notify-details">
                  {{item.title}}
                  <small class="text-muted">{{item.createdAt | formatedate}}</small>
                </p>
              </a>

              <!-- item-->
            </div>
            <div class="simplebar-content" v-else>
              <a class="dropdown-item notify-item">No New Messages!</a>
            </div>
          </div>
        </div>

        <!-- All-->
        <a
          @click="viewAll"
          v-if="notifications.length > 0"
          class="dropdown-item text-center text-primary notify-item notify-all"
        >View All</a>
      </div>
    </li>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "notificationbell",
  data() {
    return {
      isshow: false,
      isShowOrderBadge: false
    };
  },
  methods: {
    toggleNotifications() {
      this.isshow = !this.isshow;
    },
    viewAll() {
      this.$router.push({ path: "/messages" });
      this.isshow = false;
    }
  },
  computed: {
    notifications() {
      let messages = [
        ...this.$store.getters["notification/GetAllNotifications"]
      ];
      if (messages.some(Obj => Obj.message.type === "order-request") || messages.some(Obj => Obj.message.type === "manufacturer-order-request")) {
        this.isShowOrderBadge = true;
      } else {
        this.isShowOrderBadge = false;
      }
      return messages.splice(0, 5);
    }
  },
  filters: {
    formatedate: function(value) {
      if (value) {
        return moment(String(value)).format("MM/DD/YYYY hh:mm a");
      }
    }
  },
};
</script>
<style scoped>
.icon-bell {
  font-style: normal !important;
  font-weight: 1000 !important;
  font-size: 25px;
  font-variant: normal !important;
  text-transform: none !important;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.notification-list .noti-icon-badge {
  display: inline-block;
  position: absolute;
  top: 1px;
  left: 13px;
  border-radius: 50%;
  height: 7px;
  width: 7px;
  background-color: #fa5c7c;
}
.notification-list .noti-icon {
  font-size: 22px;
  vertical-align: middle;
  line-height: 70px;
}
.notification-list {
  margin-left: 0;
}
.dropdown-menu-animated.dropdown-menu-right {
  right: 0 !important;
  left: auto !important;
}
.dropdown-lg {
  width: 320px;
}
.dropdown-menu-animated {
  -webkit-animation-name: DropDownSlide;
  animation-name: DropDownSlide;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  margin: 0;
  position: absolute;
  overflow: auto;
  z-index: 1000;
}
.notification-list .noti-title {
  background-color: transparent;
  padding: 15px 20px;
}
.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.375rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: var(--secondary);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.notification-dropdown {
  position: absolute;
  transform: translate3d(-278px, 70px, 0px);
  top: 0px;
  left: 0px;
  will-change: transform;
}

.notification-scroll-container {
  max-height: 230px;
}

.simplebar-wrapper {
  margin: 0px;
}

.simplebar-content {
  padding: 0px;
}

.dropdown-menu {
  overflow:auto;
  position: absolute;
  top: 100%;
  left: 0;

  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.25rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.9rem;
  color: var(--secondary);
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #e4eaf2;
  border-radius: 0.25rem;
}
a {
  color: var(--primary);
  text-decoration: none;
  background-color: transparent;
}
.dropdown-menu.show {
  display: block;
}
.dropdown-menu[x-placement^="bottom"],
.dropdown-menu[x-placement^="left"],
.dropdown-menu[x-placement^="right"],
.dropdown-menu[x-placement^="top"] {
  right: auto;
  bottom: auto;
}
</style>